export default "__VITE_ASSET__ef8518af__"